import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { UsuarioEmpresaEditarComponent } from "./usuario-empresa-editar.component";

import { ButtonModule } from "primeng/button";;
import { InputTextModule } from "primeng/inputtext";
import { TableModule } from 'primeng/table';
import { HttpClientModule } from "@angular/common/http";
import { DividerModule } from "primeng/divider";
import { ConfirmationService } from "primeng/api";
import { FormsModule } from "@angular/forms";
import { MessagesModule } from "primeng/messages";
import { DropdownModule } from "primeng/dropdown";
import { InputSwitchModule } from "primeng/inputswitch";
import { InputMaskModule } from "primeng/inputmask";
import { PasswordModule } from 'primeng/password';
import { TreeModule } from "primeng/tree";
import { DialogModule } from "primeng/dialog";
import { TreeTableModule } from "primeng/treetable";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { FormatPipeModule } from "src/app/admihair/format-pipe/format-pipe.module";
import { TooltipModule } from "primeng/tooltip";
import { ConfirmDialogModule } from "primeng/confirmdialog";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ButtonModule,
        InputTextModule,
        TableModule,
        HttpClientModule,   
        DividerModule,
        MessagesModule,
        DropdownModule,
        InputSwitchModule,
        InputMaskModule,
        PasswordModule,
        TreeModule,
        FormatPipeModule,
        DialogModule,
        TreeTableModule,
        ProgressSpinnerModule,
        TooltipModule,
    ],
    providers: [ConfirmationService],
    declarations: [UsuarioEmpresaEditarComponent],
    exports: [UsuarioEmpresaEditarComponent]
})
export class UsuarioEmpresaEditarModule { }
